import {BudgetMassStatusChangeList} from './budget-mass-status-change-list';

export class BudgetMassStatusChange {
  statusCode: string;
  changeList: BudgetMassStatusChangeList[] = [];
}
